/**
 * Created with IntelliJ IDEA.
 * User: danielr
 * Date: 2/26/13
 * Time: 3:28 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var $ = require("jquery");

    var Validator = (function () {
        return {
            validateInputField : function (input, maxCharacters) {
                if (this.isEmpty(input)) {
                    return false;
                }
                if (typeof maxCharacters !== "undefined" && this.isInteger(maxCharacters) && input.length > maxCharacters) {
                    return false;
                }
                var re = new RegExp("<[a-zA-Z\/][^>]*>", "g");
                return (input.match(re) == null);
            },

            isEmpty : function (input) {
                return (input == null || typeof input === "undefined" || $.trim(input).length === 0);
            },

            isInteger : function (input) {
                return ($.isNumeric(input) && Math.floor(input) == input);
            },

            isValid : function (input, regex) {
                var re = new RegExp(regex, "g");
                return (input.match(re) != null);
            },

            isPasswordValid : function (input) {
                return input.length < 8 ? false : true;
            }
        };
    })();
    return Validator;

});